<template>
  <option-widget v-loading="$mip('getDiskSpaceInfo')">
    <template v-slot:heading>Дисковое пространство</template>
    <template v-slot:info>
      <div class="mb-8">
        Сейчас занято {{ currentSpace.occupied.toFixed(1) }} из {{ currentSpace.total }} Гб:
      </div>
      <div class="space-indicator mb-12">
        <el-progress
          class="flex-self-grow-1"
          :text-inside="true"
          :stroke-width="26"
          :percentage="currentSpace.occupiedPercent"
          :format="format" /> {{ currentSpace.total }}&nbsp;Гб
      </div>
      Текущая стоимость места: {{ spaceInfo.currentFee }} руб/мес
    </template>
    <template v-slot:controls>
      <div>
        Добавить места на диске:
        <el-slider
          v-model="additionSpace"
          :step="spaceInfo.changeStep"
          :max="spaceInfo.maxAdditionSpace"
          show-stops>
        </el-slider>
        <el-collapse-transition>
          <div v-if="additionSpace">
            Доп. пространство: {{ additionSpace }} гб <br>
            Стоимость: {{ additionPrice }} руб/мес
          </div>
        </el-collapse-transition>
        <el-button
          :disabled="!additionSpace || !$store.state.user.accInfo.isAdmin"
          type="primary"
          class="w-100 mt-12"
          :loading="$mip('changeDiskSpace')"
          @click="addSpace">
          Добавить
        </el-button>
      </div>
    </template>
  </option-widget>
</template>

<script>
  import OptionWidget from './OptionWidget.vue'

  export default {
    components: {
      OptionWidget
    },

    data() {
      return {
        additionSpace: 0,
        spaceInfo: {}
      }
    },

    computed: {
      currentSpace() {
        const { storageEmpty, storageTotal: total } = this.$store.state.user.accInfo
        const occupied = total - storageEmpty
        const occupiedPercent = Math.round(occupied / total * 100)
        return { occupied, total, occupiedPercent }
      },

      additionPrice() {
        return this.spaceInfo.additionSpacePrice * this.additionSpace / this.spaceInfo.changeStep
      }
    },

    async created() {
      this.getDiskInfo()
    },

    methods: {
      async addSpace() {
        await this.$http.changeDiskSpace(this.additionSpace)
        this.additionSpace = 0
        this.getDiskInfo()
        this.$notify({
          title: 'Добавление места на диске',
          message: 'Ваша заявка принята. С вами свяжется менеджер',
          type: 'success'
        })
      },

      async getDiskInfo() {
        this.spaceInfo = (await this.$http.getDiskSpaceInfo()).data
      },

      format() {
        return `${this.currentSpace.occupied.toFixed(1)} Гб`
      }
    }
  }
</script>

<style lang="scss" scoped>
.space-indicator {
  display: flex;
  max-width: 400px;
}
</style>